import { useState, useMemo } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import http from 'http'

import Overview from './Overview'
import SpeedVsTime from './SpeedVsTime'
import SpeedVsDistance from './SpeedVsDistance'

import {
  FiMap,
  FiX,
  // FiShare2
} from 'react-icons/fi'

import {
  PiSpeedometerDuotone
} from 'react-icons/pi'

import {
  RiPinDistanceLine
} from 'react-icons/ri'

import {
  CgSandClock
} from 'react-icons/cg'

import {
  BiSolidDashboard
} from 'react-icons/bi'

const TrackDetail = () => {
  const navigate = useNavigate()
  const { id: identity } = useParams()
  const [ route, setRoute ] = useState()
  const [ path, setPath ] = useState()
  const [ color, setColor ] = useState()

  useMemo( () => {
    http( {
      method: 'GET',
      url: `/track/${ identity }`,
    } )
      .then( ( { data } ) => {
        setRoute( data )
      } )
  }, [ identity ] )

  useMemo( () => {
    if ( ! route ) return

    if ( ! color ) {
      http( {
        method: 'GET',
        url: '/settings/group/color',
        params: {
          with: route.with
        }
      } )
        .then( ( { data } ) => {
          setColor( data.color )
        } )
    }

  }, [ route ] )

  const close = () => {
    navigate( -1 )
  }

  // const share = () => {
  //   html2canvas( detailRef.current )
  //     .then( canvas => {
  //       canvas.toBlob( ( blob ) => {
  //         const url = URL.createObjectURL( blob )
  //         console.log( { url } )
  //         // window.Telegram.WebApp.downloadFile( blob, 'image/png', `route-${ moment().unix() }` )
  //         window.Telegram.WebApp.downloadFile( { url, file_name: `route-${ moment().unix }` }, ( a, b ) => {
  //           console.log( { a, b } )
  //         } )
  //       }, 'image/png' )
  //     } )
  // }

  if ( ! route || ! color )
    return null

  return <div className="scroll modal full hs">

    { path === 'speed-vs-time' ? <SpeedVsTime
      route={ route }
      color={ color }
    /> : path === 'speed-vs-distance' ? <SpeedVsDistance
      route={ route }
      color={ color }
    /> : <Overview
      route={ route }
      color={ color }
    /> }

    <div className="bar space-around">
      <button
        title="detail"
        onClick={ () => setPath( 'overview' ) }
      >
        <BiSolidDashboard />
      </button>

      <button
        title="distance"
        onClick={ () => setPath( 'speed-vs-distance' ) }
      >
        <RiPinDistanceLine />
      </button>

      <button
        title="time"
        onClick={ () => setPath( 'speed-vs-time' ) }
      >
        <CgSandClock />
      </button>

      <button
        title="close"
        onClick={ close }
      >
        <FiX />
      </button>
    </div>
  </div>
}

export default TrackDetail
